import styled from '@emotion/styled';
import Header from 'app/pages/JobDetail/components/Header';

const ReportDetailHeader = styled(Header)`
  background: #ffffff;
`;

export default ReportDetailHeader;
